$(() => {
  const key = 'mirror-value-to';
  $(`[data-${key}]`).on('change', function () {
    $($(this).data(key)).text($(this).val());
  });
});
